// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import axios from 'axios'
import {setCookie} from 'tiny-cookie'

const ENDPOINTBASE = '/'

export const AXIOSAPI = axios.create({
  baseURL: ENDPOINTBASE
})

AXIOSAPI.interceptors.response.use(response => {
  return response
}, function (error) {
  if (error.response.status === 401) {
    var ref = window.location.href
    var splitRef = ref.split('#/')
    var currentPath = splitRef[1]
    var basePath = splitRef[0]
    if (currentPath.includes('referer=')) {
      // In case of a double redirect, take the first one.
      currentPath = currentPath.split('referer=')[1]
    }
    var path = basePath + '#/login?referer=' + currentPath
    window.location.href = path
  }
  return Promise.reject(error)
})

export function setAuthToken (value) {
  setCookie('jwt_token', value, { expires: 1 })
}

export function getItems (context, output, query, config, func) {
  return AXIOSAPI.get(query, config).then(response => {
    context[output] = response.data
    if (func) {
      func()
    }
  }).catch(e => {
    console.log(e)
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-common/components/requests-common.js
// module id = 10
// module chunks = 0